import { useEffect, useState } from "react";
import McqMain from "../components/TechnicalTest/McqMain";
import New_Sidebar from "../components/AssessmentSideBar";
import { useNavigate } from "react-router-dom";
import AssessmentPagesFooter from "@/components/AssessmentPagesFooter";

const TechnicalTest = () => {
	const navigate = useNavigate();
	const [currentIndex, setCurrentIndex] = useState(0);
	const [technicalQuestions, setTechnicalQuestions] = useState<any[]>([]);
	const assessmentData = JSON.parse(sessionStorage.getItem("question") || "{}");
	useEffect(() => {
		if (assessmentData.tech_questions) {
			setTechnicalQuestions(assessmentData.tech_questions);
		} else {
			sessionStorage.setItem("assessmentSection", "coding");
			navigate("/highlights");
		}
	}, []);

	return (
		<>
			<div className=" min-h-[90vh] bg-[#F9F9FA]">
				{technicalQuestions.length > 0 && (
					<>
						<New_Sidebar />
						<McqMain
							candidate_id={assessmentData.candidate_id || ""}
							questions={technicalQuestions}
							setCurrentIndex={setCurrentIndex}
							currentIndex={currentIndex}
							jobId={assessmentData.job_id}
						/>
					</>
				)}
			</div>
			<AssessmentPagesFooter />
		</>
	);
};

export default TechnicalTest;
